'use client'

import { IconArrowLeft, IconShare } from '@macarongfactory/web-icons'
import { TopNavigation } from '@macarongfactory/web-ui'
import { useRouter, useSearchParams } from 'next/navigation'
import { useRef } from 'react'

import { isMacarongApp } from '@/shared/lib'
import { MYCLE_BRIDGE_COMMANDS, requestBridge } from '@/shared/lib/appBridge'
import { ROUTES } from '@/shared/lib/routes'

import { carStoryTracking } from '../lib/tracking'
import useTrackOnVisible from '../model/useTrackOnVisible'

interface ICarStoryContentDetailTopNavigationProps {
  contentId: number
  onShareClick: () => void
}

const CarStoryContentDetailTopNavigation = ({
  contentId,
  onShareClick,
}: ICarStoryContentDetailTopNavigationProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const isFromApp = searchParams.get('referer') === 'app'

  const shareButtonRef = useRef<HTMLDivElement | null>(null)
  useTrackOnVisible({
    ref: shareButtonRef,
    tracker: () => carStoryTracking.showDetailTopShare(contentId),
  })

  const handleBack = () => {
    // 앱에서 진입한 경우 뒤로가기 시 WebView 종료
    // - referer=app: 네이티브가 명시한 진입점
    // - isMacarongApp() && history.length <= 1: 앱 웹뷰의 첫 화면(내부 라우팅 없이 새로 띄운 진입점)
    // TODO: history.length 휴리스틱 기반 진입점 판별. 네이티브가 referer=app을 붙여주면 그걸 정본으로 전환
    if (isFromApp || (isMacarongApp() && window.history.length <= 1)) {
      requestBridge.Mycle({ command: MYCLE_BRIDGE_COMMANDS.CLOSE_WEBVIEW })
      return
    }

    if (window.history.length > 1) {
      router.back()
      return
    }

    router.replace(ROUTES.CAR_STORY.HOME)
  }

  const handleShareClick = () => {
    carStoryTracking.clickDetailTopShare(contentId)
    onShareClick()
  }

  return (
    <div className='sticky top-0 z-50 bg-background-surface-default'>
      <TopNavigation
        leading={
          <TopNavigation.Leading.IconButton
            icon={<IconArrowLeft width={24} height={24} />}
            clickable={handleBack}
          />
        }
        trailing={
          <div ref={shareButtonRef}>
            <TopNavigation.Trailing.IconButton
              icon={<IconShare width={24} height={24} />}
              clickable={handleShareClick}
            />
          </div>
        }
      />
    </div>
  )
}

export default CarStoryContentDetailTopNavigation
